module.exports = __webpack_public_path__ + "/img/BGA-KR4njn.svg";